import { Component, OnInit } from '@angular/core';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { firstValueFrom } from 'rxjs';
import { EmploymentService } from 'src/app/services/employment/employment.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgIf } from '@angular/common';
import { IonicModule } from '@ionic/angular';

@Component({
    selector: 'jobplacement',
    templateUrl: './jobplacement.component.html',
    styleUrls: ['./jobplacement.component.scss'],
    standalone: true,
    imports: [
        IonicModule,
        NgIf,
        FontAwesomeModule,
    ],
})
export class JobplacementComponent implements OnInit{
  faCheck = faCheck;
  employmentData;

  constructor(
    public employmentService: EmploymentService
  ) { }

  ngOnInit() {
    firstValueFrom(this.employmentService.getLastEmploymentData())
    .then(result => {
      this.employmentData = result;
    })
  }
}
